export const getUserByToken = async (token:string) => {
  if (token) {
    const arr: any = token.split('.')[1]
    const dataUser: any = atob(arr)
    const obj: any = JSON.parse(dataUser)
    const keys: any = Object.keys(obj)
//TODO: incluir el nombreRol en la data para validaciones

    return {
      user: obj[keys[0]],
      emailaddress: obj[keys[1]],
      role: obj[keys[2]],
      idUser: obj[keys[3]],
      roleName: obj[keys[4]],
    }
  }
}
